// The scheduling defaults carry a "no reachable contact" warning. Once the user has added a
// customer-side (external) participant by hand it no longer applies (QA #14).
const NO_CONTACT = /no reachable contact/i;

export function visibleSchedulingWarnings(
  warnings: string[],
  participants: { type: 'internal' | 'external' }[],
): string[] {
  const hasCustomer = participants.some((p) => p.type === 'external');
  return hasCustomer ? warnings.filter((w) => !NO_CONTACT.test(w)) : warnings;
}
